/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/**
 * Product card colour swatches: hovering a swatch shows that colour's image on the card.
 */
(function () {
  function cardImage(swatch) {
    var card = swatch.closest('.product-item');
    return card ? card.querySelector('.product-item__primary-image') : null;
  }

  document.addEventListener('mouseover', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var swatch = event.target.closest('.product-item__colour-list [data-swatch-image]');

    if (!swatch) {
      return;
    }

    var image = cardImage(swatch);

    if (!image) {
      return;
    }

    if (!image.dataset.defaultSrc) {
      image.dataset.defaultSrc = image.getAttribute('src') || '';
      image.dataset.defaultSrcset = image.getAttribute('srcset') || '';
    }

    image.removeAttribute('srcset');
    image.setAttribute('src', swatch.getAttribute('data-swatch-image'));
  });

  document.addEventListener('mouseout', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var list = event.target.closest('.product-item__colour-list');

    if (!list || (event.relatedTarget && list.contains(event.relatedTarget))) {
      return;
    }

    var image = cardImage(list);

    if (!image || !image.dataset.defaultSrc) {
      return;
    }

    image.setAttribute('src', image.dataset.defaultSrc);

    if (image.dataset.defaultSrcset) {
      image.setAttribute('srcset', image.dataset.defaultSrcset);
    }
  });
})();

/**
 * Article table of contents: built from the H2 headings inside the article body (H3+ are ignored on purpose).
 * Stays hidden when there are fewer than 2 headings.
 */
(function () {
  var toc = document.querySelector('[data-article-toc]');
  var content = document.querySelector('.article__content');

  if (!toc || !content) {
    return;
  }

  var headings = content.querySelectorAll('h2');

  if (headings.length < 2) {
    return;
  }

  var list = toc.querySelector('.article-toc__list');
  var used = {};

  // theme.js smooth-scrolls [href^="#"] links itself and honours data-offset; keep headings clear of the sticky header
  var header = document.querySelector('.header');
  var headerSection = header && header.closest('.shopify-section');
  var offset = (headerSection ? headerSection.offsetHeight : 0) + 20;

  Array.prototype.forEach.call(headings, function (heading, index) {
    var text = heading.textContent.trim();

    if (!text) {
      return;
    }

    if (!heading.id) {
      var id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
      var unique = id;
      var n = 2;

      while (used[unique] || document.getElementById(unique)) {
        unique = id + '-' + n++;
      }

      heading.id = unique;
    }

    used[heading.id] = true;

    var item = document.createElement('li');
    var link = document.createElement('a');
    link.className = 'article-toc__link';
    link.href = '#' + heading.id;
    link.dataset.offset = offset;
    link.textContent = text;
    item.appendChild(link);
    list.appendChild(item);
  });

  toc.hidden = false;
})();
